seedWebApp.controller('StocksController', ['$scope', '$rootScope', '$uibModal', 'ToastService', 'TranslationService', 'MaterialService',
    function ($scope, $rootScope, $uibModal, ToastService, TranslationService, MaterialService) {

        console.log('stocks');
        $scope.translation = TranslationService.getActiveTranslation();
        $scope.prefs = {
            name: 'RefersGrid',
            sortByCol: null,
            canAdd: false,
            canEdit: true,
            canDelete: false,
        };

        $scope.getIDClass = function (item) {
            return 'agp-color';
        };

        $scope.getStorageClass = function (item) {
            if (item == 'SOBRA') {
                return 'qt-stocks-positive';
            }
            else {
                return 'qt-pos';
            }
        };

        $scope.columns = [
            { name: 'SkuName', id: 'SkuID', display: 'Sku', orderBy: 'asc', editable: false, width: 10, filterOptions: [] },
            { name: 'MaterialID', display: 'Item', orderBy: 'asc', editable: false, width: 10, isKey: true, filterOptions: [] },
            //{ name: 'MaterialName', display: 'Material', editable: true, width: 25/*, filterOptions: []*/  },
            { name: 'ContactID', display: 'Cliente', orderBy: 'asc', editable: false, width: 10, customClass: $scope.getIDClass, filterOptions: [] },
            { name: 'StockInvoice', display: 'Invoice', editable: true, width: 15, filterOptions: [] },
            { name: 'ContractNumber', display: 'PO#', editable: true, width: 15, filterOptions: [] },
            { name: 'BranchID', display: 'Branch', editable: true, width: 15, filterOptions: [] },
            { name: 'StockProfile', display: 'Profile', editable: true, width: 15, filterOptions: [] },
            { name: 'ReferID', display: 'Ref', editable: true, width: 15, filterOptions: [] },
            { name: 'QtAvailable', display: 'Nr Peças', filterOptions: [], editable: true, width: 15 },
            { name: 'QtLength', display: 'Comprimento', filterOptions: [], editable: true, width: 15 },
            { name: 'QtWeight', display: 'Peso', filterOptions: [], editable: true, width: 15 },
            { name: 'StorageID', display: 'Type', filterOptions: [], editable: true, width: 5, translation: true, customClass: $scope.getStorageClass },            
            { name: 'Comments', display: 'Observação', filterOptions: [], editable: true, width: 15 },            
            //{ name: 'IsSubproduct', display: 'Subproduto', filterOptions: [], editable: true, width: 15, dataType: 'boolean' },
        ];

        $scope.prefs.sortByCol = $scope.columns[0];
        $scope.prefs.sortByCol.orderReverse = false;

        $scope.loadService = MaterialService.getStocks;        
        $scope.loadColumns = MaterialService.getStocksColumns;
        $scope.resetService = MaterialService.resetCache;

        $scope.getTotal = function () {
            $scope.loadingTotal = true;
            MaterialService.getStocksCount().then(function (response) {
                $scope.loadingTotal = false;
                if (response) {
                    $scope.totalItems = response.data.TotalCount;
                    $scope.lastSync = response.data.LastSync;
                }

            });
        };

        $scope.getTotal();

        $scope.searchMode = function () {
            $scope.$broadcast('inputSearch', $scope.filterString);
        };

        $scope.doRefresh = function () {
            $scope.$broadcast('refreshServiceGrid');
        };

        $scope.toExcel = function () {
            $scope.$broadcast('toExcel', 'refers');
        };

        $scope.doInsert = function () {
            $scope.$broadcast('addItem');
        };

        //$(document).ready(function () {
        //    $scope.overflowSize = $scope.AdjustSize();
        //});
    }]
);
